import { createSelector } from 'reselect';

const getTags = state => state.tags.data;

/**
  @name getSuperTags
  Selector to obtain the super tags from the list
*/
const getSuperTags = createSelector([getTags], tags => 
  tags.filter(
    tag => !tag.location.macAddress && tag.latitude && tag.longitude
  )
);

export default getSuperTags;



// WEBPACK FOOTER //
// ./src/utils/selectors/getSuperTags.js